import { GET_LEVELS } from "constants/levels";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_LEVELS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
